import { BrickContext, CloudObject, Transaction } from 'olympe';
import { getLogger } from '@olympeio/core';
import React from 'react';

/**
 * DataGrid registry type
 */
class DataGridRegistry {
    constructor() {
        this.renderers = new Map();
    }
}

/**
 * DataGrid registry singleton
 */
const dataGridRegistry = new DataGridRegistry();

/**
 * Register a new renderer in the DataGrid registry
 * @param {!Object} renderer
 */
export function registerDataGridRenderer(renderer) {
    dataGridRegistry.renderers.set(renderer.name, renderer);
}

/**
 * Get a renderer from the DataGrid registry
 * @param {string} name
 * @return {Object}
 */
export function getDataGridRenderer(name) {
    return dataGridRegistry.renderers.get(name) || dataGridRegistry.renderers.get('DEFAULT');
}

/**
 * DEFAULT
 * Default renderer
 */
registerDataGridRenderer({
    name: 'DEFAULT',
    render: () => {
        return <p>{'INVALID RENDERER'}</p>;
    },
    renderForEdition: () => {
        return <p>{'INVALID EDIT RENDERER'}</p>;
    },
});

/**
 * Helper to use in renderForEdition()
 * @param {!BrickContext} $
 * @param {!CloudObject} object
 * @param {!Property} property
 * @param {!*} value
 */
export function updateProperty($, object, property, value) {
    const logger = getLogger('Enhanced DataGrid Edition');
    const t = Transaction.from($);
    t.update(object, property, value);
    Transaction.process($, t)
        .then(() => {
            $.set('Edited Object', object);
            $.trigger('On Object Edited');
            logger.info(`value updated: ${value}`);
        })
        .catch((error) => logger.error(`value not updated: ${value} -> ${error}`));
}
